export default function (object, filterFunction) {
  return object && Object.entries(object).reduce((obj, [key, value]) => {
    if (filterFunction({ key, value }))
      obj[key] = value
    return obj
  }, {})
}
